<template>
  <div id="app-timer">
    <secondHeader />
      <div class="main-timer">
        <sidebar />
        <div class="content-timer">
          <div class="timer-container">
          <h1 :style="{ fontFamily: font }">{{ formattedHours }}:{{ formattedMinutes }}:{{ formattedSeconds }}</h1>
          <div class="btn-area">
            <button v-on:click="startTimer" class="timer-btn btn--orange">Start</button>
            <button v-on:click="stopTimer" class="timer-btn btn--orange">Stop</button>
            <button v-on:click="resetTimer" class="timer-btn btn--stone">Reset</button>
            <button v-on:click="startFromMinusThree" class="timer-btn btn--orange">Start from -3</button>
            <div class="radio-font">
              <label><input type="radio" name="fontselect" value="Open Sans" v-model="font" /><div class="font1">09:54</div></label>
              <label><input type="radio" name="fontselect" value="Iceland" v-model="font" /><div class="font2 ">09:54</div></label>
              <label><input type="radio" name="fontselect" value="Klee One" v-model="font" /><div class="font3">09:54</div></label>
            </div>
          </div>
          <div class="timer-howto">
            <h2>使い方</h2>
            <div class="timer-howto-text">
              <p class="timer-howto-text-title">このページはタイマーのデザインをカスタマイズするためのページです。カスタマイズしたら下記の手順でOBSに追加していきます。</p>
              <p>1. OBS上部の「ドック」から「カスタムブラウザドック」を開きます。</p>
              <p>2. ドック名に「タイマー」、URLに「https://ruri.info/tool/simpletimercontrol」を入力し適用を押します。</p>
              <p>3. ボタン付きのウィンドウが表示されます。これがタイマーをスタートするためのコントローラーです。好きな場所に配置します。</p>
              <p>4. このページでデザインをカスタマイズしたら下記のボタンでリンクをコピーします。</p>
              <button @click="copyLink" class="timer-howto-copy-button">リンクをコピー</button>
              <p>5. OBSのブラウザソースを追加し、URL欄にコピーしたリンクを貼り付けます。</p>
              <p>以上で導入完了です。</p>
              <p>コントローラーで更新した値がブラウザソースに反映されます。</p>
            </div>
          </div>
          <div class="blog-area">
            <h2 class="blog-area-title">使い方はブログでチェック！</h2>
            <div class="blog-area-row">
              <div class="blog-area-thumb">
                <img class="article-list-img" src="@/assets/article/thomnail_watchparty.png">
              </div>
              <div class="blog-area-desc">
                <p>具体的な使い方や、おすすめのカスタマイズ方法はブログ記事で紹介しています。あわせてどうぞ！</p>
                <div class="blog-area-btn">
                  <a href="https://www.ruri.info/stopwatch/" target="_blank" rel="noopener noreferrer">
                    <span class="check-btn">記事をチェック</span>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div class="ad-block">
            <div class="ad">
              <InFeedAdsense
                  data-ad-layout-key="-fb+5w+4e-db+86"
                  data-ad-client="ca-pub-9016794589237931"
                  data-ad-slot="4898735474">
              </InFeedAdsense>
            </div>
          </div>
        </div>
        </div>
      </div>
  </div>
</template>

<script>
import secondHeader from "../components/secondHeader.vue"
import sidebar from "../components/sidebar.vue"
export default {
  components:{
      secondHeader,
      sidebar,
    },
  data() {
    return {
      timer: null,
      seconds: 0,
      minutes: 0,
      hours: 0,
      font:'Open Sans',
      generatedLink: '',
    }
  },
  methods: {
    startTimer() {
      this.timer = setInterval(this.incrementTime, 1000);
    },
    stopTimer() {
      clearInterval(this.timer);
    },
    resetTimer() {
      this.stopTimer();
      this.seconds = 0;
      this.minutes = 0;
      this.hours = 0;
    },
    startFromMinusThree() {
      this.resetTimer();
      this.seconds = -3;
      this.startTimer();
    },
    incrementTime() {
      if (this.seconds < 59) {
        this.seconds++;
      } else {
        this.seconds = 0;
        if (this.minutes < 59) {
          this.minutes++;
        } else {
          this.minutes = 0;
          this.hours++;
        }
      }
    },
    generateLink() {
      const baseUrl = `${window.location.origin}/tool/simpleTimerDesign`;
      this.generatedLink = `${baseUrl}?font=${encodeURIComponent(this.font)}`;
    },
    copyLink() {
      navigator.clipboard.writeText(this.generatedLink).then(() => {
        alert('リンクがコピーされました');
      });
    }
  },
  computed: {
    formattedSeconds() {
      const sign = this.seconds < 0 ? '-' : '';
      return sign + Math.abs(this.seconds).toString().padStart(2, '0');
    },
    formattedMinutes() {
      return this.minutes.toString().padStart(2, '0');
    },
    formattedHours() {
      return this.hours.toString().padStart(2, '0');
    },
  },
  mounted() {
    this.generateLink();
  },
  watch: {
    font() {
      this.generateLink();
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Iceland&family=Open+Sans:wght@500&family=Shadows+Into+Light&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Yuji+Mai&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Klee+One:wght@600&display=swap');


.main-timer {
  min-height: 100vh;
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  margin: 0 auto;
}
.content-timer {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 60px 0 60px 1.82%;
  margin: 0 auto;
}

.ad-block{
  padding: 12px 0px;
  display: block;
  width: 100%;
}
.ad {
  max-height: 300px;
  max-width: 70%;
  margin: 0 auto;
  text-align: center;
  box-sizing: border-box;
  display: block;
}

#app-timer {
  min-height: 100vh;
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  margin: 0 auto;
  background: linear-gradient(-225deg, #acb6e5 0%, #fff 25%,#fff 75%, #FFBAC3 100%);
}

.timer-container {
  width: 500px;
  text-align: center;
  margin: 0 auto;
  padding: 30px;
}

.timer-container h1{
  font-size:5rem;
}

.btn-area{
  margin-top:48px;
}

.timer-btn{
  margin: 3px 3px;
  padding:3px 12px;
  border-radius: 5px;
  appearance: none;
  border: 0;
  letter-spacing: 0.12em;
  color: #fff;
  cursor : pointer;
}

.btn--orange {
  background-color: #eb6100;
}
.btn--orange:hover{
  background: #f56500;
}

.btn--stone {
  background-color: #57534e;
}
.btn--stone:hover{
  background: #78716c;
}

.radio-font{
  display: flex;
  width: 240px;
  margin: 24px auto;
}

.radio-font label{
  display: flex;
  margin: 0 12px;
}

.font1{
  font-family: "Open Sans", sans-serif;
  margin-left:3px;
}
.font2{
  font-family: 'Iceland', cursive;
  margin-left:3px;
}

.font3{
  font-family: 'Klee One', cursive;
  margin-left:3px;
}

.timer-msg{
  display: block;
  letter-spacing: 0.12em;
  font-size:12px;
}


.content-block {
  padding: 20px; /* 必要な余白を指定 */
  max-width: 620px;
  margin: 0 auto;

  /* グラスフォーフィズム */
  background-color: rgba(255, 255, 255, 0.1); /* 背景色 */
  border: 1px solid rgba(255, 255, 255, 0.4); /* ボーダー */
  border-right-color: rgba(255, 255, 255, 0.2);
  border-bottom-color: rgba(255, 255, 255, 0.2);
  border-radius: 15px;
  -webkit-backdrop-filter: blur(20px); /* ぼかしエフェクト */
  backdrop-filter: blur(20px);
  box-shadow: 4px 4px 8px rgb(0 0 0 / 2%);
}

.content-title {
  margin-bottom: 20px; /* 必要な余白を指定 */
  text-align: center;
  letter-spacing: 3px;
  text-shadow: 2px 2px 6px rgb(210 210 210 / 80%);
}

.content-row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 20px; /* 必要な余白を指定 */
}

.content-thumb {
    flex: 0 0 auto;
    margin-right: 20px; /* 必要な余白を指定 */
    width: 50%;
}

.content-thumb img{
    object-fit: contain;
    width: 100%;
}

.content-desc {
  width: 50%;
  word-wrap: break-word;
  font-size: 14px;
  letter-spacing: 2px;
}

.content-desc a{
  text-decoration:none;
}

.ariticle-btn{
  background: linear-gradient(-225deg, #acb6e5 0%, #C5C1FF 56%, #FFBAC3 100%);
  opacity: 0.75;
  border-radius: 10px;
  padding: 5px 12px ;
  color: white;
}

.ariticle-btn:hover{
  transform: translateY(-5px);
  box-shadow: 0 7px 34px rgba(50,50,93,.1), 0 3px 6px rgb(0 0 0 / 10%);
  transition: all .5s;
}

@media screen and (max-width: 600px) {
    .content-row {
        flex-direction: column;
    }

    .content-thumb, .content-desc {
        margin-right: 0;
        width: 100%;
    }
}
.blog-block{
  margin-top:2rem;
}

.blog-area{
  padding: 20px;
  max-width: 620px;
  margin: 3rem auto;
  border-bottom: 1px solid #212121;
  border-top: 1px solid #212121;
}

.blog-area-title{
  margin-bottom: 20px;
  text-align: center;
  letter-spacing: 3px;
  text-shadow: 2px 2px 6px rgb(210 210 210 / 80%);
}

.blog-area-row{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  margin-top: 24px;
}

.blog-area-thumb{
  flex: 0 0 auto;
  margin-right: 20px;
  width: 50%;
}

.blog-area-thumb img{
    object-fit: contain;
    width: 100%;
}

.blog-area-desc{
  width: 50%;
  word-wrap: break-word;
  font-size: 14px;
  letter-spacing: 2px;
  text-align: left;
}

.blog-area-desc a{
  text-decoration:none;
}

.blog-area-btn{
  margin-top:2rem;
}

.check-btn{
  background-color: #212121;
  opacity: 0.75;
  border-radius: 8px;
  padding: 5px 12px ;
  color: white;
  transition: all .5s;
}

.check-btn:hover{
  box-shadow: 0px 5px 6px 0px rgba(0, 0, 0, 0.35);
	transform: translateY(-4px);
}


.timer-howto {
  margin: 20px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.timer-howto h2 {
  margin-bottom: 10px;
}

.timer-howto-text {
  margin-bottom: 10px;
  text-align: left;
  width: 500px;
  line-height: 1.5;
}
.timer-howto-text-title {
  margin-bottom: 10px;
}
.timer-howto-copy-button {
  margin-bottom: 10px;
  padding: 10px 20px;
  background-color: #4c5c8a; /* 緑色の背景 */
  color: white; /* 白色の文字 */
  border: none; /* 枠線なし */
  border-radius: 5px; /* 角を丸くする */
  cursor: pointer; /* カーソルをポインターにする */
  transition: background-color 0.3s; /* 背景色の変化にアニメーションを追加 */
}

.timer-howto-copy-button:hover {
  background-color: #3b466a; /* ホバー時の背景色 */
}
</style>